import { render, staticRenderFns } from "./HeaderSalvi.vue?vue&type=template&id=1cfaab3a&scoped=true&"
import script from "./HeaderSalvi.vue?vue&type=script&lang=js&"
export * from "./HeaderSalvi.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSalvi.vue?vue&type=style&index=0&id=1cfaab3a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfaab3a",
  null
  
)

export default component.exports